import {
  Avatar,
  Typography,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import PropTypes from "prop-types";
import RatioMonitor from "./RatioMonitor";

const UserCard = ({ user, onClick }) => {
  const produtividade =
    user.minRegistrados * 100 / user.minTotal > 100
      ? 100
      : ((user.minRegistrados * 100) / user.minTotal).toFixed(0);

  return (
    <Card onClick={onClick} sx={{
      width: "100%",
      maxWidth: 420,
      boxShadow: "0 8px 28px rgba(26, 56, 101, 0.12), 0 2px 6px rgba(100,125,238,0.08)",
      borderRadius: "16px",
      border: "1px solid rgba(100, 125, 238, 0.15)",
      background: "linear-gradient(145deg, #f5f7fa 0%, #eef1f8 100%)",
      overflow: "hidden",
      position: "relative",
      cursor: "pointer",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 14px 36px rgba(26, 56, 101, 0.2), 0 4px 12px rgba(100,125,238,0.15)",
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0, left: 0, right: 0,
        height: "4px",
        background: "linear-gradient(90deg, #269FFB, #647DEE, #1A3865)",
      },
    }}>
      <CardContent sx={{ pt: 3, pb: "16px !important" }}>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Box sx={{
            p: "2px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #269FFB, #647DEE, #1A3865)",
            boxShadow: "0 4px 12px rgba(100, 125, 238, 0.35)",
            flexShrink: 0,
          }}>
            <Avatar
              src={user.avatar}
              alt={user.nomeColaborador}
              sx={{ width: 56, height: 56, border: "2px solid white" }}
            />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{
              fontWeight: 700,
              fontSize: "0.9rem",
              color: "#1A3865",
              lineHeight: 1.3,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {user.nomeColaborador}
            </Typography>
            <Typography sx={{ fontSize: "0.75rem", color: "#6b7a99", mt: 0.2 }}>
              {user.cargoColaborador}
            </Typography>
            {user.nomeGrupo && (
              <Box sx={{
                display: "inline-block",
                mt: 0.5,
                px: 1,
                py: 0.2,
                borderRadius: "8px",
                background: "rgba(100, 125, 238, 0.1)",
                border: "1px solid rgba(100, 125, 238, 0.25)",
              }}>
                <Typography sx={{ fontSize: "0.68rem", color: "#647DEE", fontWeight: 600 }}>
                  {user.nomeGrupo}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Box sx={{
          borderTop: "1px solid rgba(100, 125, 238, 0.12)",
          pt: 1.5,
        }}>
          <RatioMonitor
            maxValue={produtividade}
            teclasDigitadas={user.teclasDigitadas}
          />
        </Box>

      </CardContent>
    </Card>
  );
};

UserCard.propTypes = {
  onClick: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    nomeColaborador: PropTypes.string.isRequired,
    cargoColaborador: PropTypes.string.isRequired,
    produtividade: PropTypes.number,
    minRegistrados: PropTypes.number,
    minTotal: PropTypes.number,
    dias: PropTypes.number,
    primAtividade: PropTypes.string,
    ultAtividade: PropTypes.string,
    avatar: PropTypes.string,
    teclasDigitadas: PropTypes.number,
    nomeGrupo: PropTypes.string,
  }).isRequired,
};

export default UserCard;
